import { Box, Container, VStack, useToast, Text } from "@chakra-ui/react";
import { ReactComponent as Logo } from "assets/logos/s-logo.svg";
import PinInput from "components/Input/PinInput";
import Button from "components/Button/Button";
import { useState, useRef, useEffect } from "react";
import Recaptcha from "react-google-recaptcha";
import { useHistory, useLocation } from "react-router-dom";
import constant from "config/constant";
import useAuth from "hooks/useAuth";
import { convertNumberMS } from "util/convertNumberToTime";
import { post } from "util/axiosLib";

const ResetCode = () => {
  const pinMax = 6;
  const toast = useToast();
  const history = useHistory();
  const location = useLocation();

  const { logout, token } = useAuth();

  const searchParams = new URLSearchParams(location.search);

  const recaptchaInstanceRef = useRef();
  const [pin, setPin] = useState("");
  const [email, setEmail] = useState(searchParams.get("email"));

  const [initialTime, setInitialTime] = useState(600);
  const [startTimer, setStartTimer] = useState(true);
  const [disableRequest, setDisableRequest] = useState(true);
  const [loading, setLoading] = useState(false);
  const [resetloading, setResetLoading] = useState(false);

  const [hasCompleteValues, setHasCompleteValues] = useState(false);

  const handlePin = (pin) => {
    const isValid = String(pin).length === pinMax;
    if (!isValid) setHasCompleteValues(false);
    setPin(pin);
  };

  const headers = {
    authorization: token,
    "Content-Type": "application/json",
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (navigator.onLine === true) {
      setLoading(true);
      try {
        const captcha = await recaptchaInstanceRef.current?.executeAsync();

        const response = await post(
          `${process.env.REACT_APP_API_ENDPOINT}/auth/forgotPassword?humanKey=${captcha}`,
          {
            email,
            code: pin,
            ...headers,
          }
        );

        if (response.status === "success") {
          setLoading(false);

          console.log(response.data, "DATA SUCCESS");
          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });
          history.replace(constant.PAGES.LOGIN);
        }

        if (response.status === 201) {
          setLoading(false);

          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });

          history.replace(constant.PAGES.LOGIN);
        }

        if (response.status === 202) {
          setLoading(false);

          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });

          history.replace(constant.PAGES.LOGIN);
        }
      } catch (error) {
        setLoading(false);
        console.log(error, "DATA error here");
        await recaptchaInstanceRef.current?.reset();
        toast({
          position: "bottom-right",
          title: "Oops!!",
          description: error.error,
          status: "error",
          duration: 18000,
          isClosable: true,
        });
      }
    } else {
      toast({
        position: "bottom-right",
        title: "Network Error!!",
        description: "Please check your network connection",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  const handleResendPin = async (e) => {
    e.preventDefault();

    if (navigator.onLine === true) {
      setResetLoading(true);
      try {
        const captcha = await recaptchaInstanceRef.current?.executeAsync();

        const response = await post(
          `${process.env.REACT_APP_API_ENDPOINT}/auth/forgotPassword?humanKey=${captcha}`,
          { email, ...headers }
        );

        if (response) {
          setDisableRequest(true);
          setInitialTime(60);
          setStartTimer(true);
        }

        if (response.status === "success") {
          setResetLoading(false);

          console.log(response.data, "DATA HERE");
          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });
        }

        if (response.status === 202) {
          setResetLoading(false);

          console.log(response.data, "DATA HERE");

          toast({
            position: "bottom-right",
            title: "Success",
            description: response.data.message,
            status: "success",
            duration: 9000,
            isClosable: true,
          });
        }
      } catch (error) {
        setLoading(false);
        console.log(error, "error here");
        await recaptchaInstanceRef.current?.reset();
        toast({
          position: "bottom-right",
          title: "Oops!!",
          description: error.error,
          status: "error",
          duration: 18000,
          isClosable: true,
        });
      }
    } else {
      toast({
        position: "bottom-right",
        title: "Network Error!!",
        description: "Please check your network connection",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    if (!email) {
      const _email = prompt("Enter your email address");
      _email && setEmail && setEmail(_email);
    }

    if (initialTime > 0) {
      setTimeout(() => {
        setInitialTime(initialTime - 1);
      }, 1000);
    }

    if (initialTime === 0 && startTimer) {
      setStartTimer(false);
      setDisableRequest(false);
    }
  }, [email, startTimer, initialTime]);

  return (
    <VStack py={["10px", "20px"]} minH="100vh" alignItems="center">
      <Container maxW="container.sm">
        <Box bg="#fcfcfc" p={["10px", "16px", "28px"]}>
          <VStack>
            <Box
              cursor="pointer"
              w={["100px", "initial"]}
              as={Logo}
              onClick={() => {
                logout();
                history.replace("/");
              }}
            />

            <Text
              textAlign="center"
              fontSize={["32px", "3xl"]}
              mt="24px !important">
              Reset Code
            </Text>
            <Text textAlign="center" fontSize={["sm", "md"]} color="#4e4b66">
              Enter the 6-digit reset code sent to your phone
            </Text>
          </VStack>

          <Box mt="50px">
            <form onSubmit={handleSubmit}>
              <VStack>
                <PinInput
                  isRequired
                  limit={pinMax}
                  size={["lg"]}
                  onChange={handlePin}
                  onComplete={() => setHasCompleteValues(true)}
                />

                <Recaptcha
                  ref={recaptchaInstanceRef}
                  sitekey={process.env.REACT_APP_RECAPTCHA}
                  size={"invisible"}
                />

                <Button
                  disabled={!hasCompleteValues || loading}
                  isLoading={loading}
                  minW="204px"
                  minH="56px"
                  fontWeight="normal"
                  mt="30px !important"
                  type="submit">
                  Submit
                </Button>

                {/* <Timer mt="50px !important" /> */}

                <Text mt="50px !important">{convertNumberMS(initialTime)}</Text>

                <Button
                  isLoading={resetloading}
                  disabled={disableRequest}
                  variant="ghost"
                  fontWeight="normal"
                  mt="10px !important"
                  bg="transparent"
                  color="#02a438"
                  size="sm"
                  w="fit-content"
                  onClick={handleResendPin}>
                  Resend Code
                </Button>
              </VStack>
            </form>
          </Box>
        </Box>
      </Container>
    </VStack>
  );
};

export default ResetCode;
